const interactiveFieldMixin = (Base = class Empty {}) => class extends Base {


	prepareInteractiveField({eventsEnabled = true, asyncEvents = true} = {}) {
		this.eventsEnabled = eventsEnabled;
		this.asyncEvents = asyncEvents;
		this.input = this.getInput();
		this.enabled = !this.classList(this.element).contains('disabled');
		this.initEvents();
	}


	canFocus() {
		return true;
	}


	initEvents() {
		this.initFocusEvent();
		this.initBlurEvent();
		this.initChangeEvent();
	}


	enableEvents() {
		this.eventsEnabled = true;
		return this;
	}


	disableEvents() {
		this.eventsEnabled = false;
		return this;
	}


	initFocusEvent() {
		this.listeners.focus = this.events.on(this.element, 'focusin', this.onFocus.bind(this));
	}


	initBlurEvent() {
		this.listeners.blur = this.events.on(this.element, 'focusout', this.onBlur.bind(this));
	}


	initChangeEvent() {
		this.listeners.change = this.events.on(this.element, 'change', this.onChange.bind(this));
	}


	onFocus(event) {
		if (this.eventsEnabled) {
			this.triggerEvent('focus', event);
		}
	}


	onBlur(event) {
		if (this.eventsEnabled) {
			this.triggerEvent('blur', event);
		}
	}


	onChange(event) {
		if (this.eventsEnabled) {
			this.triggerEvent('change', event);
		}
	}


	focus(value, suppressEvent = false) {
		const oldEventsEnabled = this.eventsEnabled;
		if (suppressEvent) {
			this.eventsEnabled = false;
		}
		this.setFocus();
		this.eventsEnabled = oldEventsEnabled;
		return this;
	}


	blur(value, suppressEvent = false) {
		const oldEventsEnabled = this.eventsEnabled;
		if (suppressEvent) {
			this.eventsEnabled = false;
		}
		this.setBlur();
		this.eventsEnabled = oldEventsEnabled;
		return this;
	}


	triggerEvent(type, event) {
		const callback = () => {
			if (this.element) {
				this.events.trigger(this.element, 'field:' + type, {component: this, originalEvent: event});
			}
		};
		if (this.asyncEvents) {
			setTimeout(callback, 0);
		} else {
			callback();
		}
		return this;
	}

	enable() {
		if (!this.enabled) {
			this.classList(this.element).remove('disabled');
			this.enableInput();
			this.enabled = true;
		}
		return this;
	}

	disable() {
		if (this.enabled) {
			this.classList(this.element).add('disabled');
			this.disableInput();
			this.enabled = false;
		}
		return this;
	}


	toggleEnabled(value = null) {
		if (value === null) {
			value = !this.enabled;
		}
		return (value ? this.enable() : this.disable());
	}


	// to be overriden
	getInput() {}

	setFocus() {}

	setBlur() {}

	enableInput() {}

	disableInput() {}

};


export default interactiveFieldMixin;
